import {STATS} from '../model/data.ts';
import "./Stats.css";

export default function Stats() {
    return (
        <section className="possibilities-stats" data-reveal>
            <h2 className="possibilities-stats__title">Статистика</h2>

            <div className="possibilities-stats__grid">
                {STATS.map((stat, index) => {
                    return (
                        <div key={index} className="stat-card">
                            <h3 className="stat-card__title">{stat.title}</h3>

                            <div className="stat-card__value-wrap">
                                <span className="stat-card__value">{stat.value}</span>
                                <span className="stat-card__unit">{stat.unit}</span>
                            </div>

                            <p className="stat-card__label">{stat.label}</p>
                            <p className="stat-card__description">{stat.description}</p>
                        </div>
                    );
                })}
            </div>
        </section>
    );
}